import PropTypes from 'prop-types';
import { CartContainer, Skeleton } from '@aimsos/ui';

/**
 * Loading placeholder for a dashboard card.
 *
 * Shaped like `DashboardBuilderCard` and wrapped in the same `CartContainer`,
 * so swapping one for the other causes no shift — the same rule the widget
 * library's skeleton follows.
 *
 * The three rows mirror the `EntityList` row: icon + title + section with the
 * status, time and kebab on the right; the description; and the creator /
 * widget count meta with the tags.
 */
function DashboardCardSkeleton({ count }) {
  return Array.from({ length: count }, (_, index) => (
    <CartContainer key={`dashboard-skeleton-${index}`} size="S" variant="neutral">
      <div className="flex w-full flex-col gap-2">
        <div className="flex items-center justify-between gap-2">
          <div className="flex min-w-0 flex-1 items-center gap-2">
            <Skeleton width={24} height={24} borderRadius={6} />
            <Skeleton width="34%" height={14} borderRadius={6} />
            <Skeleton width={120} height={12} borderRadius={6} />
          </div>
          <div className="flex shrink-0 items-center gap-2">
            <Skeleton width={64} height={20} borderRadius={9999} />
            <Skeleton width={48} height={12} borderRadius={6} />
            <Skeleton width={28} height={28} borderRadius={6} />
          </div>
        </div>

        <Skeleton width="62%" height={14} borderRadius={6} />

        <div className="flex items-center justify-between gap-4">
          <Skeleton width={180} height={14} borderRadius={6} />
          <div className="flex flex-wrap items-center justify-end gap-2">
            <Skeleton width={70} height={20} borderRadius={9999} />
            <Skeleton width={86} height={20} borderRadius={9999} />
          </div>
        </div>
      </div>
    </CartContainer>
  ));
}

DashboardCardSkeleton.propTypes = {
  count: PropTypes.number.isRequired,
};

export default DashboardCardSkeleton;
